import { Link } from 'react-router-dom';
import { BELIMO_HASH_PREFIX } from 'src/BELIMO_HASH_PREFIX';
import { Button } from 'src/modules/common/components/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';

export const ProjectEmptySelection = () => (
    <div className="vss-project-empty-selection">
        <div className="vss-project-empty-selection__empty-title">
            <I18n messageId={MESSAGES.projectPageEmptyTitle}/>
        </div>

        <div className="vss-project-empty-selection__empty-description">
            <I18n messageId={MESSAGES.projectPageEmptyDescription}/>
        </div>

        <Button kind="secondary" as={Link} to={`${BELIMO_HASH_PREFIX}/`}>
            <I18n messageId={MESSAGES.projectPageHomePage}/>
        </Button>
    </div>
);
